import React from "react";

export default function ColumnMappingHeader({
  title = "Column Mapping & Rules",
  expanded = false,
  editable = false,
  showAutoMap = true,
  onAutoMap,
  onToggleExpand,
  extraActions,
  showEdit = false
}) {
  return (
    <div className="p-4 flex items-center justify-between border-b bg-white">

      {/* LEFT */}
      <div className="flex items-center gap-2">

        <span className="material-symbols-outlined text-primary">
          grid_on
        </span>

        <h3 className="text-lg font-bold text-slate-900">
          {title}
        </h3>

        {editable &&  (
          <span className="px-2 py-1 text-xs rounded-full bg-blue-100 text-blue-700">
            Edit Mode
          </span>
        )}

      </div>

      {/* RIGHT */}
      <div className="flex items-center gap-2">

        {showEdit?extraActions:<></>}

        {showAutoMap && onAutoMap && (
          <button
            onClick={onAutoMap}
            className="px-3 py-2 text-sm font-medium text-blue-600 hover:bg-blue-50 rounded-lg"
          >
            Auto Map
          </button>
        )}

        {onToggleExpand && (
          <button
            onClick={onToggleExpand}
            title={expanded ? "Collapse" : "Expand"}
            className="h-9 w-9 rounded-lg bg-slate-100 hover:bg-slate-200 flex items-center justify-center"
          >
            <span className="material-symbols-outlined text-slate-700 text-[18px]">
              {expanded
                ? "close_fullscreen"
                : "open_in_full"}
            </span>
          </button>
        )}

      </div>

    </div>
  );
}